const Backbone = require('backbone');
const AddToCartView = require('app/views/store/pages/products/addtocart');
const SquareFootPriceView = require('app/views/store/pages/products/squarefootprice');
const FinishesView = require('app/views/store/pages/products/finishes');
const BookAppointmentView = require('app/views/store/pages/products/book_appointment');
const FinishNameView = require('app/views/store/pages/products/finishname');
const InventoryView = require('app/views/store/pages/products/inventory');
const LeadTimeView = require('app/views/store/pages/products/leadtime');
const EstimatedDeliveryView = require('app/views/store/pages/products/estimated_delivery');
const QuickShipView = require('app/views/store/pages/products/quick_ship');
const LDIEstDeliveryView = require('app/views/store/pages/products/ldi_est_delivery');
const StockMessageView = require('app/views/store/pages/products/stockmessage');
const PriceView = require('app/views/store/pages/products/price');
const SavingsView = require('app/views/store/pages/products/savings');
const CallToActionView = require('app/views/store/pages/products/calltoaction');
const RatingView = require('app/views/store/pages/products/rating');
const VariationView = require('app/views/store/pages/products/variations');
const QuantityView = require('app/views/store/common/quantity');
const FinishSamplesView = require('app/views/store/pages/products/finish_samples');
const gtmHelper = require('lib/helpers/gtm_helper');

require('jquery.scrollto');

var PurchaseView = Backbone.View.extend({
	el: '#product',

	events: {
		'click .js-show-parts': '_showParts',
		'click .js-show-variation-help': '_trackVariationHelp'
	},

	initialize: function(opts) {
		let hasPricingByUOM = opts.parentView.model.hasPricingByUOM(),
			hasSales;

		window.dataLayer.finishes.forEach((finish) => {
			if (finish.sale) {
				hasSales = true;
			}
		});

		this.parentView = opts.parentView;

		this.productModel = this.parentView.model;

		if (hasSales) {
			import('app/views/store/pages/products/_sale_box').then((SalesView) => {
				this.childViews.sales = new SalesView();
			});
		}

		this._initFinishesView();

		this.childViews.price = new PriceView({
			model: this.parentView.model
		});

		this.childViews.finishName = new FinishNameView();

		this.childViews.finishSamples = new FinishSamplesView({
			model: this.parentView.model
		});

		this.childViews.inventory = new InventoryView({
			model: this.parentView.model
		});
		this.childViews.leadTime = new LeadTimeView({
			model: this.parentView.model
		});
		if (window.dataLayer.isPurchaseByAppointmentOnly) {
			this.childViews.bookAppointment = new BookAppointmentView({
				model: this.parentView.model,
				el: '.js-book-appointment-wrapper'
			});
		} else {
			if (window.dataLayer.isQuickShipEnabled) {
				this.childViews.quickShipView = new QuickShipView({
					model: this.parentView.model,
					el: '.js-quick-ship-wrapper'
				});
			} else {
				this.childViews.estimatedDeliveryView = new EstimatedDeliveryView({
					model: this.parentView.model
				});
			}
		}

		if (window.BCOM.theme.isLivingDirect) {
			this.childViews.LDIEstDelivery = new LDIEstDeliveryView({
				model: this.parentView.model
			});
		}

		if (window.dataLayer.spifInfo) {
			import('app/views/store/pages/products/spif').then((SpifView) => {
				this.childViews.spifs = new SpifView({
					model: this.parentView.model,
					spifInfo: window.dataLayer.spifInfo
				});
			});
		}

		this.childViews.callToAction = new CallToActionView({
			model: this.parentView.model
		});

		this.childViews.stockMessage = new StockMessageView({
			model: this.parentView.model
		});

		this.childViews.savings = new SavingsView();

		this.childViews.rating = new RatingView({
			el: '.js-reviews-link'
		});
		// Should be able to bind to multiple add to cart buttons Const added for LDI vs Build themes
		const $addToCartButton = hasPricingByUOM ? this.$('.js-square-foot-add-to-cart') : this.$('.cart-button');

		this.childViews.addToCart = new AddToCartView({
			purchaseView: this,
			model: this.parentView.model,
			el: window.BCOM.theme.isLivingDirect ? $addToCartButton : $addToCartButton.first()
		});

		if (hasPricingByUOM) {
			this.childViews.squareFootPrice = new SquareFootPriceView({
				model: this.parentView.model,
				el: this.$('.sqft-price-box')
			});
		}

		if (window.dataLayer.hasAddToCartMapBuster) {
			import('app/views/store/pages/products/map_buster').then((MapBusterView) => {
				this.childViews.mapBuster = new MapBusterView();
			});
		}

		this.childViews.variations = new VariationView({
			model: this.parentView.model,
			parentView: this
		});

		this.childViews.quantity = new QuantityView({
			el: this.$('#main-product-quantity .js-quantity'),
			id: 'main-product-quantity'
		});

		if (this.parentView.model.hasAvailabilityByLocation()) {
			import('app/views/store/pages/products/availability_by_location').then(({ AvailabilityByLocationView }) => {
				this.childViews.availabilityByLocation = new AvailabilityByLocationView({
					purchaseView: this,
					finishes: this.parentView.model.finishes,
					parentView: this.parentView,
					quantityView: this.childViews.quantity
				});
			});
		}

		if (window.BCOM.device.isMobile) {
			import('app/views/store/common/menu').then((MenuView) => {
				this.mobileFinishMenu = new MenuView({
					openButton: '.js-add-to-cart-panel .js-open-finish-menu',
					menuContainer: '.js-finishes-menu',
					contentContainer: '.js-finishes-menu .finishes',
					closeContainer: '.js-finishes-menu .js-header'
				});
				this.listenTo(Backbone, 'finishmenu:toggle', () => {
					this.mobileFinishMenu.toggleMenu();
				});
				if (this.parentView.model.get('variations')) {
					var variations = this.parentView.model.get('variations');
					variations.forEach((variation) => {
						this.mobileVariationMenu = new MenuView({
							openButton: `.js-add-to-cart-panel .js-open-variation-menu-${variation.variationId}`,
							menuContainer: `.js-variation-menu-${variation.variationId}`,
							closeContainer: `.js-variation-menu-${variation.variationId} .js-header`
						});
					});
				}
			});
		}

		if (this.productModel.get('isBundle')) {
			import('views/store/pages/products/bundled_products').then((BundledProductsView) => {
				this.childViews.bundledProducts = new BundledProductsView({
					finishesView: this.childViews.finishesView
				});
			});
		}

		/**
		 * Update the hidden input optionList every time a priced option changes
		 * Note: this message comes from the option_groups collection
		 */
		this.listenTo(Backbone, 'optionList:updated', this._updateOptionList, this);
	},

	showError: function(data) {
		if (window.BCOM.device.isMobile) {
			var $fieldEl = $(data.field);

			if (data.label) {
				$(data.label).addClass('error-label');
			}
			$fieldEl.addClass('error-field');
			$('.js-add-to-cart-error').removeClass('hide');
			$('.js-add-to-cart-error-message').text(data.message);

			$('.add-to-cart-wrap button, .js-finishes-panel').addClass('error-border');

			if (!window.BCOM.util.isElementInViewport($fieldEl)) {
				$(window).scrollTo($fieldEl.offset().top - 50, 500);
			}
		}
	},

	hideError: function() {
		if (window.BCOM.device.isMobile) {
			$('.js-add-to-cart-error').addClass('hide');
			$('.js-add-to-cart-error-message').text('');
			$('.error-label').removeClass('error-label');
			$('.error-border').removeClass('error-border');
		}
	},

	_showParts: function() {
		$('.js-parts-tab').tab('show');
		$(window).scrollTo($('#parts'), 500);
	},

	/**
	 * _updateOptionList - Call back for priced option updates
	 * @private
	 * @param  {Array} data UniqueIDs of selected priced options
	 */
	_updateOptionList: function(data) {
		this.$('#optionList').val(data.join());
	},

	_initFinishesView: function() {
		this.childViews.finishesView = new FinishesView({
			pageView: this.parentView,
			collection: this.parentView.model.finishes,
			model: this.parentView.model
		});
	},
	_trackVariationHelp(event) {
		let $target = $(event.target),
			data = {},
			trackingString = $target.data('omniture').replace(/\s+/g, '-');
		data.linkName = trackingString;

		gtmHelper.fireEvent({
			event: 'generic-click-tracking',
			linkName: data.linkName
		});

		Backbone.trigger('track:link', data);
	}
});

module.exports = PurchaseView;
